import type { FC } from "react";
import { useState } from "react";
import type { INotification } from "app/components/sharingAssetModal/types";
import { Checkbox } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

interface INotificationManager {
    notification: INotification;
    setNotification: (notification: INotification) => void;
    checkboxText?: string;
}

const { midnight, carbon } = colorsPalettes;

const DEFAULT_TEXT_AREA_BORDER = `1px solid ${midnight[50]}`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const CheckboxContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`;

const TextArea = styled.textarea`
    height: 120px;
    width: 100%;
    border: ${DEFAULT_TEXT_AREA_BORDER};
    ${setFontVariant("body2", carbon[500])};
    resize: none;
    &:focus {
        border: ${DEFAULT_TEXT_AREA_BORDER};
    }
`;

const PlaceHolder = styled.span<{ isVisible: boolean }>`
    position: absolute;
    left: 8px;
    bottom: 20px;
    visibility: ${({ isVisible }) => (isVisible ? `visible` : "hidden")};
`;

const EmailContainer = styled.div`
    position: relative;
`;

const i18n = i18nFilter();

export const NotificationManager: FC<INotificationManager> = (props) => {
    const { notification, setNotification, checkboxText } = props;
    const [showPlaceHolder, setShowPlaceHolder] = useState<boolean>(true);
    const { shouldNotify, notificationContent } = notification;
    const onNotifyUsersToggle = () => {
        setNotification({ ...notification, shouldNotify: !shouldNotify });
    };

    const onTextChange = (event) => {
        if (showPlaceHolder) {
            setShowPlaceHolder(false);
        }
        setNotification({ ...notification, notificationContent: event.target.value });
    };
    return (
        <Container>
            <CheckboxContainer>
                <Checkbox
                    label={checkboxText ?? i18n("keyword.groups.sharing.notify.label")}
                    onClick={onNotifyUsersToggle}
                    selected={shouldNotify}
                />
            </CheckboxContainer>
            {shouldNotify ? (
                <EmailContainer>
                    <TextArea
                        value={notificationContent}
                        onChange={onTextChange}
                    />
                    <PlaceHolder isVisible={showPlaceHolder}>
                        {i18n("asset.sharing.notification.content.placeholder")}
                    </PlaceHolder>
                </EmailContainer>
            ) : null}
        </Container>
    );
};
